export var VERSION = '1.11.0';
//# sourceMappingURL=version.js.map